import type { Clean } from './types'
// /api/reorder increments exactly the rows whose persisted order changes.
// Keep EVERY row in the inverse snapshot, including unchanged rows: a concurrent
// note/payment/date/insert/delete must refuse Undo atomically, never overwrite it.
export function inverseDayOrder(moved: readonly Pick<Clean, 'id' | 'version' | 'sort_order'>[]): { id: number; version: number; sort_order: number | null }[] {
  return moved.map((row, index) => ({ id: row.id, version: row.version + (row.sort_order === (index + 1) * 10 ? 0 : 1), sort_order: row.sort_order ?? null }))
}
